import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from '@constants';
import { useStore } from '@hooks';
import { observer } from 'mobx-react';
import StoreSetupManual from '../../../Profile/components/AccountSettings/components/Integrations/components/StoreSetupManual';
import { MODE } from '../../../Profile/components/AccountSettings/components/Integrations/constants';
import InviteDeveloperCard from './components/InviteDeveloperCard';
import { InviteCardWrapper, LayoutContainer, StoreSetupWrapper } from './styled';

const ManualApi = observer(() => {
    const store = useStore();
    const { isManualStoreWithNoCampaigns } = store.accountsStore;

    if (!isManualStoreWithNoCampaigns) {
        return <Navigate to={ROUTE_PATHS.CAMPAIGNS_CREATE_STEP_1} replace />;
    }

    return (
        <LayoutContainer>
            <StoreSetupWrapper>
                <StoreSetupManual
                    title='Connection via API'
                    ordersTitle='Orders setup (optional)'
                    customersTitle='Customers setup (optional)'
                    showErrorWhenReused
                    variant={MODE.CAMPAIGN}
                />
            </StoreSetupWrapper>
            <InviteCardWrapper>
                <InviteDeveloperCard />
            </InviteCardWrapper>
        </LayoutContainer>
    );
});

export default ManualApi;
